import { useState } from "react";
import api from "@/api/client";
import { CreditCard, CheckCircle2 } from "lucide-react";

export default function RedeemCardForm({ onSuccess }) {
  const [cardCode, setCardCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const redeem = async () => {
    const clean = cardCode.replace(/\D/g, "");
    if (clean.length !== 13) { setErr("الكود يجب أن يكون 13 رقماً"); return; }
    setBusy(true); setErr(""); setMsg("");
    try {
      const { data } = await api.post("/wallet/redeem-card", { code: clean });
      setMsg(`تم شحن ${data.amount} د.ل بنجاح! الرصيد الجديد: ${data.balance.toFixed(2)} د.ل`);
      setCardCode("");
      onSuccess?.(data.balance);
    } catch (e) {
      const m = e?.response?.data?.detail || e?.message || "فشل شحن الكرت";
      setErr(m);
    } finally { setBusy(false); }
  };

  return (
    <div className="bg-white rounded-3xl talabya-shadow-soft p-5" data-testid="redeem-card-section">
      <div className="flex items-center gap-2 mb-3">
        <CreditCard size={18} className="text-primary-brand"/>
        <h2 className="font-black text-lg" style={{fontFamily:"Cairo"}}>شحن المحفظة بكرت</h2>
      </div>
      <p className="text-xs text-[var(--text-secondary)] mb-3">أدخل رمز الكرت المكوّن من 13 رقم لإضافة قيمته إلى محفظتك.</p>
      <input
        type="text"
        inputMode="numeric"
        maxLength={17}
        dir="ltr"
        value={cardCode}
        onChange={(e) => setCardCode(e.target.value.replace(/[^\d\s-]/g, ""))}
        className="w-full px-4 py-3 rounded-xl border border-[var(--border)] bg-[var(--surface-alt)] focus:bg-white focus:border-primary-brand focus:outline-none font-mono tracking-widest text-center text-lg font-bold"
        placeholder="—————————————"
        data-testid="redeem-code-input"
      />
      {msg && (
        <div className="mt-3 text-sm bg-green-50 text-green-700 px-3 py-2 rounded-lg flex items-start gap-2" data-testid="redeem-msg">
          <CheckCircle2 size={16} className="mt-0.5 shrink-0"/>{msg}
        </div>
      )}
      {err && <div className="mt-3 text-sm bg-red-50 text-red-600 px-3 py-2 rounded-lg" data-testid="redeem-err">{err}</div>}
      <button
        onClick={redeem}
        disabled={busy || cardCode.replace(/\D/g, "").length !== 13}
        className="mt-3 w-full py-3 rounded-xl bg-primary-brand text-white font-black disabled:opacity-60 flex items-center justify-center gap-2"
        data-testid="redeem-submit"
      >
        <CreditCard size={16}/> {busy ? "جاري الشحن..." : "شحن المحفظة"}
      </button>
    </div>
  );
}
